function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89C429"
    },
    d: "M511.344,274.266C511.77,268.231,512,262.143,512,256C512,114.615,397.385,0,256,0S0,114.615,0,256 c0,117.769,79.53,216.949,187.809,246.801L511.344,274.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#709E21"
    },
    d: "M511.344,274.266L314.991,77.913L119.096,434.087l68.714,68.714C209.522,508.787,232.385,512,256,512 C391.243,512,501.976,407.125,511.344,274.266z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "278.328,333.913 255.711,77.913 119.096,77.913 119.096,311.652 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E8E6E6"
    },
    points: "392.904,311.652 392.904,155.826 337.252,133.565 314.991,77.913 255.711,77.913  256.067,333.913 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "314.991,155.826 314.991,77.913 392.904,155.826 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.096,
    y: 311.652,
    style: {
      fill: "#B3DA73"
    },
    width: 273.809,
    height: 122.435
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.424,354.863l-7.796,9.233c-3.48-4.238-8.626-6.887-13.32-6.887 c-8.4,0-14.757,6.659-14.757,15.363c0,8.854,6.357,15.589,14.757,15.589c4.466,0,9.612-2.422,13.32-6.206l7.871,8.324 c-5.677,5.827-14.076,9.687-21.871,9.687c-15.969,0-27.849-11.73-27.849-27.245c0-15.287,12.184-26.79,28.305-26.79 C213.954,345.933,222.126,349.413,227.424,354.863z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.772,351.684l-5.071,10.519c-5.6-3.255-12.638-5.524-16.952-5.524 c-3.482,0-5.827,1.287-5.827,3.86c0,9.157,28.001,3.936,28.001,23.082c0,10.595-9.384,16.196-21.19,16.196 c-8.854,0-17.936-3.33-24.218-8.476l5.221-10.368c5.449,4.768,13.623,7.947,19.148,7.947c4.237,0,6.886-1.589,6.886-4.617 c0-9.384-28.001-3.783-28.001-22.552c0-9.763,8.4-15.969,21.116-15.969C263.529,345.781,271.323,348.128,276.772,351.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.372,399.362l-20.585-52.975h14.379l13.547,38.975l13.547-38.975h13.848l-20.811,52.975H301.372 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.4a7f84863040c585ddba3f85d460a68a.svg";
export { ForwardRef as ReactComponent };